import dateFormatType from '@/constants/dateFormatType';
import { pageSizeEnum } from '@/constants/pageSizeOptionList';
import { workerMonthlyAttendanceSearchType } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceSearchTypeOptionList';
import { workerMonthlyAttendanceUseYnType } from '@/constants/workerMonthlyAttendance/workerMonthlyAttendanceUseYnTypeOptionList';
import { format } from 'date-fns';
const today = new Date();
const initialMonth = format(today, dateFormatType.MONTH);
const initialFromTime = '07';
const initialToTime = '06';
const firstPage = 1;
export const getInitialState = () => ({
    filterOption: {
        yearMonth: initialMonth,
        fromTimePeriod: initialFromTime,
        toTimePeriod: initialToTime,
        workerUseYn: workerMonthlyAttendanceUseYnType.OK,
        searchType: workerMonthlyAttendanceSearchType.WORKER_NAME,
        searchKey: null,
    },
    pageSize: pageSizeEnum['50'],
    pageNumber: firstPage,
    sortOption: null,
    // 데이터
    workerMonthlyAttendanceList: [],
    paginationData: {},
});
const states = getInitialState();
export default states;
